import "./App.css";
import Nabvar from "./components/Nabvar";
import Home from "./pages/Home";

function App() {
  return (
    <div className="App">
      <Nabvar />
      <Home />
    </div>
  );
}

export default App;
